export enum EPageKind {
  Default = 'default',
  Rent = 'rent',
  DailyRent = 'dailyRent',
  Sale = 'sale',
  ResidentialComplexes = 'residentialComplexes',
  Commercial = 'commercial',
  Countryside = 'countryside',
}
